import { DriverDetails, useGetDriverById } from "modules/drivers";
import { useParams } from "react-router-dom";

const EditDriverPage = () => {
  const { editableDriverId } = useParams();

  const { driver: editableDriver, isLoading: isEditableDriverLoading } =
    useGetDriverById(editableDriverId as string, { cacheTime: 0 });

  return (
    <DriverDetails
      editableDriver={editableDriver}
      isEditableDriverLoading={isEditableDriverLoading}
    />
  );
};

export default EditDriverPage;
